import './RichTextLink.scss';

import { ReactNode } from 'react';

import { useExternalHomepageConfig } from '../../hooks/useExternalHomepageConfig';
import { Link } from '../Link';

const className = 'c-RichTextLink';

type RichTextLinkProps = {
  children?: ReactNode;
  newTab?: boolean | null;
  url: string;
};

export const RichTextLink = ({ children, newTab, url }: RichTextLinkProps) => {
  const { getLocalisedUrl } = useExternalHomepageConfig();

  const newTabProps = newTab
    ? { rel: 'noopener noreferrer', target: '_blank' }
    : {};

  if (url.startsWith('/')) {
    return (
      <Link to={url} className={className} {...newTabProps}>
        {children}
      </Link>
    );
  }

  return (
    <a href={getLocalisedUrl(url)} className={className} {...newTabProps}>
      {children}
    </a>
  );
};
